import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetAssistanceComponent } from './get-assistance/get-assistance.component';
import { DialogPopupComponent } from './dialog-popup/dialog-popup.component';
import { PopupSurveyComponent } from './popup-survey/popup-survey.component';
import { AssistanceComponent } from './assistance/assistance.component';
import { SharedComponentsRoutingModule } from './shared-components-routing.module';
import { RatingModule } from 'ng-starrating';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { OffersComponent } from './offers/offers.component';
import { EmojiScaleComponent } from './emoji-scale/emoji-scale.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    GetAssistanceComponent,
    DialogPopupComponent,
    PopupSurveyComponent,
    AssistanceComponent,
    OffersComponent,
    EmojiScaleComponent
  ],
  imports: [
    CommonModule,
    SharedComponentsRoutingModule,
    RatingModule,
    IvyCarouselModule,
    TranslateModule
  ],
  exports: [
    GetAssistanceComponent,
    DialogPopupComponent,
    PopupSurveyComponent,
    AssistanceComponent,
    OffersComponent,
    EmojiScaleComponent
  ],
})
export class SharedComponentsModule { }
